import BaseStyle from '@primevue/core/base/style';

var KeyFilterStyle = BaseStyle.extend({
  name: 'keyfilter-directive'
});

export { KeyFilterStyle as default };
//# sourceMappingURL=index.mjs.map
